import { CopyMetadataFromParent, Property } from '@skylab-shared/core';
import { VatSummary } from '../document/vat-summary';
import { SaleDocumentModel } from './sale-document.model';

@CopyMetadataFromParent()
export class SaleDocumentAdjustmentModel extends SaleDocumentModel {
    @Property()
    public adjustmentReasonId: number;

    @Property()
    public originalDocumentId: number;

    @Property()
    public originalDocumentVersion: string;

    public vatSummary: VatSummary;

    @Property(Boolean, { nullable: false })
    public adjustPaymentDate: boolean;
}
